/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types';
import { useTranslate } from 'react-polyglot';

import CalendarPicker from '../Calendar/CalendarPicker';
import Icon from '../Icon';

import moment from 'moment';
import { DEFAULT_MOMENT_FORMATS } from '../../services/moment.service';
import { CALENDAR_YEARS_PERIOD, INPUT_MODE } from '../../constants/enums';
import { isEmptyOrWhiteSpaces } from '../../utils/checkValue';

const InputDate = ({
    input,
    label,
    err,
    mode,
    required,
    yearsPeriod,
    meta: { error, warning, touched }
}) => {
    const hasError = err || (touched && error);
    const translate = useTranslate();

    const hocRef = useRef(null);
    const [open, setOpen] = useState(false);

    const [dateLabel, setDateLabel] = useState(translate(label));

    useEffect(() => {
        if (input.value) {

            const newLabel = formatDateLabel(input.value)

            // Checking when date picker should be closed after changing input.value
            // In case the label "Choose Date" is displayed and we select the date
            // In case of editing, the input.value is displayed and we select a new date
            if (label && dateLabel !== translate(label) && dateLabel !== newLabel) {
                setOpen(false);
            }

            setDateLabel(newLabel);

        }
    }, [input.value])

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (hocRef && hocRef.current && !hocRef.current.contains(event.target)) {
            setOpen(false);
        }
    }

    const formatDateLabel = (value) => {
        return moment(value).format(DEFAULT_MOMENT_FORMATS.DATE);
    }

    return (
        <div ref={hocRef} className="a-input-group-date">
            <div className="a-input-group" onClick={() => setOpen(!open)}>
                <div className={`a-input -datetime -${mode} ${!isEmptyOrWhiteSpaces(input.value) ? "-filled" : ""} ${open ? "-active" : ""} ${hasError ? "-error" : ""}`} onClick={setOpen}>
                    <span className="datetime-value">{dateLabel}</span>
                </div>
                <label className={`-${mode} ${required ? "-required" : ""}`}>{translate(label)}</label>
                <div className="a-input-icon"><Icon name="calendar" color={open ? "#ea68a8" : "#615F7C"} /></div>
                {hasError && <span className="a-input-error">{translate(err || error)}</span>}
            </div>
            {open &&
                <CalendarPicker
                    input={input}
                    label={label}
                    display={open}
                    yearsPeriod={yearsPeriod}
                />
            }
        </div>
    )
}

InputDate.propTypes = {
    input: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    err: PropTypes.string,
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    meta: PropTypes.object,
    mode: PropTypes.oneOf([
        INPUT_MODE.DARK,
        INPUT_MODE.LIGHT
    ]),
    yearsPeriod: PropTypes.oneOf([
        CALENDAR_YEARS_PERIOD.NEXT,
        CALENDAR_YEARS_PERIOD.PREVIOUS
    ]),
    required: PropTypes.bool
}

InputDate.defaultProps = {
    input: {},
    meta: {},
    label: 'general.date',
    err: "",
    mode: INPUT_MODE.DARK,
    required: false,
    yearsPeriod: CALENDAR_YEARS_PERIOD.NEXT
}

export default InputDate;